/**
 * YOUR SCORE (DESIGN-CHANGELOG 2026-09-03 "Scores"; `design/GT Mine.dc.html`,
 * the `scShow` block). AA phase 2.
 *
 * 480px. Header art · name · dev, then eleven cells 0–10 — one tap sets AND
 * closes — and a footer with `✕ CLEAR MY SCORE` when one is set. The header's
 * note says the one thing about a score that is not obvious from a number:
 * THE PARTY SEES IT. Escape and the overlay click close it (`Modal`).
 */

import { CoverArt } from '../../components/CoverArt.tsx';
import { useArt } from '../../components/useArt.ts';
import { useQd } from '../../store/index.ts';
import { scoreModalVM } from '../../store/selectors.ts';
import { Modal } from '../components/Modal.tsx';

const MONO = 'var(--gt-font-mono)';

export default function ScoreModal(): JSX.Element | null {
  const s = useQd();
  const v = scoreModalVM(s);
  const art = useArt((v?.id ?? 0) + 'w', v?.hdrCands ?? []);
  if (!v) return null;

  return (
    <Modal
      onClose={() => s.closeScore()}
      width={480}
      label="Your score modal"
      header={{ title: 'YOUR SCORE', titleClr: 'var(--gt-text)', titleFs: '10px', note: 'THE PARTY SEES IT' }}
    >
      <div style={{ display: 'flex', gap: 13, padding: '15px 18px', borderBottom: '1px solid var(--gt-line)' }}>
        <div
          style={{
            position: 'relative',
            width: 132,
            height: 62,
            flex: 'none',
            background: v.fall,
            overflow: 'hidden',
            border: '1px solid var(--gt-line)',
          }}
        >
          <CoverArt style={{ position: 'absolute', inset: 0 }} fs={10} ini={v.ini} hasCover={art.hasCover} cover={art.cover} />
        </div>
        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 7, justifyContent: 'center' }}>
          <span style={{ fontFamily: 'var(--gt-font-sans)', fontWeight: 600, fontSize: 15, color: 'var(--gt-text)' }}>{v.name}</span>
          <span style={{ fontFamily: MONO, fontSize: 9, letterSpacing: '.07em', color: 'var(--gt-faint)' }}>{v.dev}</span>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 5, padding: '16px 18px' }}>
        {v.cells.map((c) => (
          <div
            key={c.key}
            onClick={() => void s.setScore(v.id, c.v)}
            className="d-hov-acc-bd"
            style={{
              flex: 1,
              height: 36,
              boxSizing: 'border-box',
              border: '1px solid ' + c.bd,
              background: c.bg,
              color: c.fg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: 'var(--gt-font-pixel)',
              fontSize: 10,
              cursor: 'pointer',
            }}
          >
            <span style={{ transform: 'translateY(0.13em)' }}>{c.label}</span>
          </div>
        ))}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 9,
          padding: '13px 18px',
          borderTop: '1px solid var(--gt-line)',
          background: 'var(--gt-raised)',
        }}
      >
        {v.hasScore ? (
          <span
            onClick={() => void s.setScore(v.id, null)}
            className="d-hov-acc2"
            style={{ fontFamily: MONO, fontSize: 9, letterSpacing: '.07em', color: 'var(--gt-text-5)', cursor: 'pointer' }}
          >
            ✕ CLEAR MY SCORE
          </span>
        ) : null}
        <div style={{ flex: 1 }} />
        <span
          onClick={() => s.closeScore()}
          style={{
            fontFamily: MONO,
            fontSize: '9.5px',
            letterSpacing: '.07em',
            color: 'var(--gt-text-5)',
            border: '1px solid var(--gt-border-2)',
            padding: '9px 12px',
            cursor: 'pointer',
          }}
        >
          CANCEL
        </span>
      </div>
    </Modal>
  );
}
